
import Vue from "vue";
import ListDeletedForms from "./ListDeletedForms.vue";
import ListDeletedSurveys from "./ListDeletedSurveys.vue";
import AddFormThemes from "./forms/AddFormThemes.vue";
import AddPrebuiltForms from "./forms/AddPrebuiltForms.vue";
import RemoveFormThemes from "./forms/RemoveFormThemes.vue";
import RemovePrebuiltForms from "./forms/RemovePrebuiltForms.vue";
import EditPrebuiltForms from "./forms/EditPrebuiltForms.vue";
import AddSurveyThemes from "./surveys/AddSurveyThemes.vue";
import RemoveSurveyThemes from "./surveys/RemoveSurveyThemes.vue";
import AddPrebuiltSurveys from "./surveys/AddPrebuiltSurveys.vue";
import EditPrebuiltSurveys from "./surveys/EditPrebuiltSurveys.vue";
import RemovePrebuiltSurveys from "./surveys/RemovePrebuiltSurveys.vue";
export default Vue.extend({
  components: {
    ListDeletedForms,
    ListDeletedSurveys,
    AddFormThemes,
    AddPrebuiltForms,
    RemoveFormThemes,
    RemovePrebuiltForms,
    EditPrebuiltForms,
    AddSurveyThemes,
    RemoveSurveyThemes,
    AddPrebuiltSurveys,
    EditPrebuiltSurveys,
    RemovePrebuiltSurveys,
  }
});
